<script>
export default {
    props: ['data', 'type'],
    name: "homeBanner",
    data() {
        return {
            swiperOptions1: {
                // direction: 'vertical',
                observer: true,
                observeParents: true,
                simulateTouch: false,
                loop: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.swiper-pagination',
                },
            },
            swiperOptions2: {
                // direction: 'vertical',
                observer: true,
                observeParents: true,
                simulateTouch: false,
                loop: false,
                pagination: {
                    el: '.swiper-pagination',
                },
            },
        };
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper
        }
    },
    components: {
        
    },
    mounted() {
        
    },
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <swiper class="home_banner" ref="mySwiper" :options="data.length > 1 ? swiperOptions1 : swiperOptions2" v-if="data.length > 0">
        <swiper-slide v-for="(item, index) in data" :key="index">
            <div class="layout_bg bg" :style="`background-image: url(${item.image});`"></div>
            <div class="layout_main content">
                <div class="text1 text_shadow">{{ item.name1 }}</div>
                <div class="text2 text_shadow">{{ item.name2 }}</div>
                <div class="desc text_shadow" v-html="$textToHtml(item.desc)"></div>
                <a class="mask" v-if="type == 'about'" :href="item.link"></a>
                <a class="btn layout_flex_center" :href="item.link" v-else>了解更多</a>
            </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
</template>

<style scoped lang="scss">
.home_banner{
    width: 100%;
    height: 7.5rem;
    @media only screen and (max-width: 750px) {
        height: 10.64rem;
    }
    .content{
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        color: #fff;
        line-height: 1.5;
        @media only screen and (max-width: 750px) {
            text-align: center;
            padding-top: 2rem;
        }
        .text1{
            font-size: .5rem;
            @media only screen and (max-width: 750px) {
                font-size: .36rem;
            }
        }
        .text2{
            font-size: .55rem;
            font-weight: bold;
            margin-bottom: .1rem;
            @media only screen and (max-width: 750px) {
                font-size: .48rem;
                margin: .4rem 0;
            }
        }
        .desc{
            font-size: .28rem;
            line-height: 1.8;
        }
        .btn{
            position: absolute;
            right: 0;
            bottom: 1rem;
            font-size: .2rem;
            width: 1.85rem;
            height: .45rem;
            background: #fff;
            color: var(--font_color);
            border-radius: .1rem;
            @media only screen and (max-width: 750px) {
                position: relative;
                right: auto;
                bottom: auto;
                margin: 1rem auto 0;
                font-size: .28rem;
                width: 2.4rem;
                height: .58rem;
                text-shadow: none;
            }
        }
        .mask{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
    }
    .bg{
        position: absolute;
        z-index: -1;
    }
    .swiper-pagination{
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: .06rem;
        height: 100%;
        top: 0;
        right: 2.1rem;
        bottom: auto;
        left: auto;
        transform: none;
        width: auto;
        @media only screen and (max-width: 750px) {
            width: 100%;
            height: auto;
            top: auto;
            right: auto;
            left: 0;
            bottom: .6rem;
            flex-direction: row;
            gap: .1rem;
        }
        /deep/ .swiper-pagination-bullet{
            opacity: 1;
            margin: 0;
            width: .12rem;
            height: .12rem;
            background: none;
            border: 1px solid #fff;
            &-active{
                background: #fff;
            }
            @media only screen and (max-width: 750px) {
                width: .16rem;
                height: .16rem;
            }
        }
    }
}
</style>